<app-scanner (readResult)="scanSuccessHandler($event)"></app-scanner>

<app-validation-popup [reset]="reset" [ticketResponse]="ticketResponse" [mode]="mode" [offline]="offline"></app-validation-popup>